import React from 'react';
import { MarketingLayout, DocumentationBrowser } from '@byscott-io/corebyscott';

export default function HelpPage() {
  return (
    <MarketingLayout>
      <div className="max-w-6xl mx-auto px-4 py-8">
        <DocumentationBrowser title="Affiliate Help" basePath="/help" />
      </div>
    </MarketingLayout>
  );
}
